import * as Yup from 'yup';
import {yupStringMin} from '../../../../functions/validationsYup';
import {combineDateTime} from '../../../../library/dates';
import {getValidityOverlapError, getValidityGapError} from '../basicTicket/ticketValidity/validityValidation';
import store from '../../../../store';

const validateEndDateAfterStartDate = (endDate, context) => {
    const {startDateActive, endDateActive, startDate, startTime, endTime} = context.parent;

    if(!startDateActive || !endDateActive || !startDate || !startTime || !endDate || !endTime) {
        return true;
    }

    const startDateTime = combineDateTime(startDate, startTime);
    const endDateTime = combineDateTime(endDate, endTime);

    return endDateTime > startDateTime;
};

const validateDateWithinEventRange = (date, time, t) => {
    if(!date || !time) return true;

    const event = store.getState().event;
    const dateTime = combineDateTime(date, time);

    if(event?.timeEnd && dateTime > event.timeEnd) return t('validityAfterEventError');
    return true;
};

const draftParams=validator=>['draft', {
    is: 1,
    then: validator,
    otherwise: validator.required()
}];

const draftMinParams=(validator)=>['draft', {
    is: 1,
    then: validator,
    otherwise: validator.min(1)
}];

const numberValidator=Yup.number();
const dateValidator=Yup.date();
const stringValidator=Yup.string();
const arrayValidator=Yup.array();

const pricesValidator=Yup.array().of(
    Yup.object().shape({
        price: Yup.number().when(...draftParams(Yup.number().min(0).max(99999))),
        title: Yup.string()
    })
);

export const  getValidationSchema = (t) =>
    Yup.object().shape({
        title: yupStringMin().required(),
        text: yupStringMin(),
        limit: numberValidator.when(...draftParams(numberValidator)),
        prices:pricesValidator.when(...draftMinParams(pricesValidator)),
        payments: Yup.object().shape({}),
        crowd: Yup.object().shape({
            limit: Yup.number().nullable(true),
            isMemberLimit: Yup.boolean().nullable(true),
        }),
        description:Yup.object().shape({
            description:yupStringMin().max(999),
            summary: yupStringMin()
        }),
        extras:Yup.array().of(Yup.object().shape({
            title:  stringValidator.required(),
            price:  numberValidator.required(),
            amount: numberValidator.required(),
            limit:  numberValidator.required()
        })),
        // Validity fields validation
        startDateActive: Yup.boolean(),
        startDate: Yup.number().nullable()
            .when('startDateActive', {
                is: true,
                then: (schema) => schema.required(t('errorRequired')),
                otherwise: (schema) => schema.nullable()
            })
            .test('startDateWithinEventRange', '', function(value) {
                const result = validateDateWithinEventRange(value, this.parent.startTime, t);
                return result === true ? true : this.createError({message: result});
            }),
        startTime: Yup.number().nullable().when('startDateActive', {
            is: true,
            then: (schema) => schema.required(t('errorRequired')),
            otherwise: (schema) => schema.nullable()
        }),
        endDateActive: Yup.boolean(),
        endDate: Yup.number().nullable()
            .when('endDateActive', {
                is: true,
                then: (schema) => schema.required(t('errorRequired')),
                otherwise: (schema) => schema.nullable()
            })
            .test('endDateAfterStartDate', t('preSaleUntilError'), (value, context) =>
                validateEndDateAfterStartDate(value, context))
            .test('endDateWithinEventRange', '', function(value) {
                const result = validateDateWithinEventRange(value, this.parent.endTime, t);
                return result === true ? true : this.createError({message: result});
            }),
        endTime: Yup.number().nullable().when('endDateActive', {
            is: true,
            then: (schema) => schema.required(t('errorRequired')),
            otherwise: (schema) => schema.nullable()
        }),
        displayBeforeSale: Yup.boolean(),
        displayAfterSale: Yup.boolean(),
    })
        .test('validityOverlapError', '', function(value) {
            const tickets = store.getState().tickets?.tickets;
            const currentTid = store.getState().tickets?.currentTicket?.tid;
            const overlapError = getValidityOverlapError(tickets, currentTid, value, t, true);
            if(overlapError) return this.createError({message: overlapError});
            return true;
        })
        .test('validityGapError', '', function(value) {
            const tickets = store.getState().tickets?.tickets;
            const currentTid = store.getState().tickets?.currentTicket?.tid;
            const gapError = getValidityGapError(tickets, currentTid, value, t, true);
            if(gapError) return this.createError({message: gapError});
            return true;
        });

const amountValidator=Yup.number();

export const validationCourse =(hasDates)=>Yup.object().shape({
    amount:amountValidator.when(...draftParams(amountValidator)),
    course: Yup.object().when('draft',{
        is: 1,
        then: Yup.object().shape({
            startDate: hasDates?dateValidator.required():dateValidator,
            endDate:hasDates?dateValidator.required():dateValidator,
            meetings: hasDates?arrayValidator.min(1):arrayValidator,
        }),
        otherwise:Yup.object().shape({
            startDate:dateValidator.required(),
            endDate:dateValidator.required(),
            meetings: arrayValidator.min(1),
        })
    }),
    users:arrayValidator.when(...draftMinParams(arrayValidator)),
    // description:Yup.object().shape({
    //     description:Yup.string().max(700)
    // }),
});
